module.exports = __webpack_public_path__ + "assets/ziyuan_10.b925336a.svg";